export default __webpack_public_path__ + "static/calendars-unite-b6fc292163ad6a704248ede217377752.svg";